// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__158jj","calendarButtons":"ClockData_calendarButtons__1qwyo"};